module.exports = __webpack_public_path__ + "img/Satanic Messiah EP.203cb027.jpg";